import globalData from "@/assets/js/common/global"
/**
 * 隐藏手机号码
 * @param val {Number, String} 转换的字符串对象
 * @param retain {Number} 保留位数
 * @return {String}
 */
export const privatePhone = function (val, retain = 4) {
  if (!NUMBER(val) || String(val).length !== 11 || retain == 0) return val;
  let phone = String(val)
  let digit = 11 - 3 - retain
  let reg = new RegExp(`^(\\d{3})\\d{${digit}}(\\d{${retain}})$`)
  return mobile.replace(reg, `$1${'*'.repeat(digit)}$2`)
};

/**
 * 格式化时间
 * @param val {time, cFormat} 转换的字符串对象
 */
export const parseTime = function (time, cFormat) {
  if (arguments.length === 0 || !time) {
    return null
  }
  const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
  let date
  if (typeof time === 'object') {
    date = time
  } else {
    if ((typeof time === 'string')) {
      if ((/^[0-9]+$/.test(time))) {
        // support "1548221490638"
        time = parseInt(time)
      } else {
        // support safari
        // https://stackoverflow.com/questions/4310953/invalid-date-in-safari
        time = time.replace(new RegExp(/-/gm), '/')
      }
    }

    if ((typeof time === 'number') && (time.toString().length === 10)) {
      time = time * 1000
    }
    date = new Date(time)
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  }
  const time_str = format.replace(/{([ymdhisa])+}/g, (result, key) => {
    const value = formatObj[key]
    // Note: getDay() returns 0 on Sunday
    if (key === 'a') {
      return ['日', '一', '二', '三', '四', '五', '六'][value]
    }
    return value.toString().padStart(2, '0')
  })
  return time_str
}
/**
 * 表单无数据处理
 * @param val {time, cFormat} 转换的字符串对象
 */
export const formatenodata = function (data) {
  if (!data || data == null) {
    return '未填写'
  } else {
    return data;
  }
}


/**
 * 处理男女性别
 */
export const convertSex = function (sexid) {
  if (sexid != null) {
    let sexname = sexid == 1 ? '男' : '女'
    return sexname
  }
}

/**
 * 处理出生年月转换年龄
 */
export const convertAge = function (date) {
  var age = '';
  var str = date.replace(/年|月/g, "-").replace(/日/g, "");
  var r = str.match(/^(\d{1,4})(-|\/)(\d{1,2})\2(\d{1,2})$/);
  if (r == null) return '';
  var d = new Date(r[1], r[3] - 1, r[4]);
  if (d.getFullYear() == r[1] && (d.getMonth() + 1) == r[3] && d.getDate() == r[4]) {
    var Y = new Date().getFullYear();
    age = (Y - r[1]);
    return age;
  } else {
    return ''
  }
}

/**
 * 处理默认数据不友好数据例如 0000-00-00
 */
export const cleardefaultdata = function (data) {
  if (data == '0000-00-00') {
    return ''
  }
  else {
    return data
  }
}




// WEBPACK FOOTER //
// ./src/assets/js/filters.js